
export const past2025 = {
  subTitle: '—— 西丽湖金融科技大学生挑战赛',
  subTitleEn: 'FinTechathon 深圳国际金融科技大赛',
  titleImg: require('@/assets/img/2025.png'),
  mobileTitleImg: require('@/assets/img/2025.png'),
  introduction: {
    subTitle: '微众银行金融科技高校技术大赛',
    subTitleEn: 'FinTechathon',
    // certificate: require('../../../assets/img/awards/certificate.png'),
    // mobileCertificate: require('../../../assets/img/awards/certificate-wap.png'),
    intro: [
      '12 月 5 日 -7 日，由深圳市地方金融管理局进行战略指导，深大微众金融科技学院、微众银行、InfoQ 极客传媒、狗熊会等多方联合举办的 2025 FinTechathon 深圳国际金融科技大赛——西丽湖金融科技大学生挑战赛（以下简称“大赛”）在深圳圆满收官。作为连续七年举办的高规格青年赛事，本届大赛再次有效衔接高校创新成果与真实金融场景，持续发挥产教融合的桥梁作用。',
      '赛事期间，人工智能赛道同步举办了黑客松，两个赛道的入围团队分别进行了激烈而精彩的现场答辩，并于 12 月 7 日举行了大赛颁奖典礼，正式揭晓获奖名单。'
    ],
    poster: require('@/assets/transSave/resource/image/2025/mainimg.jpg'),
    video: 'https://media001.geekbang.org/customerTrans/7e27d07d27d407ebcc195a0e78395f55/3c5a2d92-19afd5c4cbb-0000-0000-01d-dbacd.mp4'
  },

  finalist: {
    // title: '入围决赛队伍',
    // subTitle: 'FINALIST',
    content: [
      {
        alias: 'first',
        title: '一等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/2025/aiimage1.jpg'),
            title: '港科广 DSA 金融科技小组',
            alias: 'ai',
            type_title: '人工智能赛道',
            product: '《灵操盘》',
            member: '余昊霖、王力平、朱心怡、王昊',
            school: '香港科技大学（广州）',
            pro_intro: '灵操盘是一款零代码量化交易引擎，旨在解决量化投资门槛高、策略落地难的问题，将自然语言投资想法自动“编译”为可回测并可执行的量化策略 。系统核心由金融知识驱动的大模型与多智能体协同架构构成，覆盖数据处理、策略建模、风控预警到实盘执行全链路，实现策略持续优化与全周期管理 。在技术上，项目构建国内A股规模领先的动态金融知识图谱，并引入可信推理、幻觉筛除与市场情绪自适应预测等创新机制，提高策略可信度与实战表现 。灵操盘能够服务专业机构与个人投资者，适用于策略孵化、智能投顾、自动化交易等多元落地场景，助力AI驱动的普惠量化与金融科技产业升级 。'
          },
          {
            image: require('@/assets/transSave/resource/image/2025/saimage1.jpg'),
            title: '反诈天团',
            product: '《面向反洗钱欺诈检测的可扩展混合专家集成模型》',
            alias: 'statistics',
            type_title: '数据分析赛道',
            member: '朱珉谊、杨雨函、王玮越、徐亦佳、许文轩',
            school: '北京大学',
            pro_intro: '面对全球洗钱活动日益复杂化与隐蔽化挑战，传统反洗钱系统存在高误报、高成本及难以适应新型犯罪的痛点，我们提出了面向反洗钱欺诈检测的可扩展混合专家集成系统，创新性地融合多种异构模型，实现对交易行为的全维度、无死角动态监测。本方案的核心优势在于其高度的可扩展性与低成本运维能力，能够快速集成新算法、适配新场景，极大降低了金融机构的技术门槛与长期维护成本。我们的方案旨在为金融机构提供降本增效、实现普惠智能风控的产品。'
          }
        ]
      },
      {
        alias: 'second',
        title: '二等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/2025/aiimage2.jpg'),
            title: 'AI4Fin',
            product: '《易金经 —— LLM 驱动下融合数据底座和智能投资的金融服务解决方案》',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '周全世、安妮、朱殷、李柏莹',
            school: '首都经济贸易大学',
            pro_intro: '“易金经”的命名灵感源于中国著名古籍《易筋经》。原典强调通过调理筋脉、贯通经络，重塑身体的内在运行结构。本项目以此为喻，融会贯通生成式人工智能、知识图谱和图机器学习等技术体系，实现金融知识智能分析与抽取、多模态数据底座自动化构建、交易信号生成与智能资产配置等，最终形成“知识抽取——数据底座——智能决策”的金融服务闭环，打造易金经——LLM驱动下融合数据底座和智能投资的金融服务解决方案。',
          },
          {
            image: require('@/assets/transSave/resource/image/2025/saimage2.jpg'),
            title: '护卫九五',
            product: '《基于多维度数据的小微企业信用评分模型》',
            alias: 'statistics',
            type_title: '数据分析赛道',
            member: '程晗晓、杨轩、李嘉豪、张诗令',
            school: '北京师范大学珠海校区',
            pro_intro: '小微企业是国民经济的重要组成部分，构建一套精准而高效的信用评级体系具有重要的现实意义。本作品使用第三方机构的真实信用评级数据，收集了企业的多个维度信息，以建立可靠的信用评分体系。我们尝试了五种传统的统计和机器学习分类方法，结果发现模型在测试数据上的预测精度表现不佳，且某些机器学习算法缺乏可解释性和稳定性。因此，本作品拟构建一个兼顾预测精度和可解释性的统计模型，即两阶段逻辑回归模型，并据此设计了一款具备强解释性的信用评分卡。该模型不仅能够有效区分“好”客户与“坏”客户，还通过评分卡形式提供透明的决策机制，使业务人员能够清晰理解评分依据。',
          }
        ]
      },
      {
        alias: 'third',
        title: '三等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/2025/aiimage3.jpg'),
            title: 'one piece',
            product: '《FinAgent：AI 驱动的智能财务管理与投资助手》',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '彭冠润、张成镡',
            school: '香港科技大学（广州）',
            pro_intro: `核心痛点： 针对传统记账应用录入繁琐、反馈僵化，以及个人投资者风险评估主观、决策盲目滞后等行业痛点，本项目提出了一站式智能解决方案 。\n技术创新： 系统融合多模态感知与知识蒸馏技术（Qwen3-VL），实现了非结构化账单的自动化精准录入与端侧隐私保护 。创新性构建“数据闭环生态”，利用提示词工程从账单反推用户画像，以客观消费数据替代主观问卷进行风险校准 。\n应用价值： 基于多智能体协同架构（Risk/Analyst/Trade Agents），FinAgent 基于微众银行用户账单数据，打通了从智能记账、用户画像构建、建设性消费引导到智能投资建议的全流程 。它实现了真正的个性化和智能化，赋予用户从“被动记录”向“主动增值”转变的财富管理能力 。`,
          },
          {
            image: require('@/assets/transSave/resource/image/2025/saimage3.jpg'),
            title: '留存π队',
            product: '《数字银行客户流失精准防控 ——基于TabNet-LightGBM 模型的动态优化框架》',
            alias: 'statistics',
            type_title: '数据分析赛道',
            member: '许傅乐、丘雅萱、岳余静、任文君、汪东民',
            school: '深圳大学、兰州大学',
            pro_intro: '本作品针对银行信用卡客户流失率高、干预成本高、ROI低的痛点，构建了“预测-分层-干预-优化”全流程智能决策框架。首创TabNet-LightGBM融合架构，通过TabNet的注意力机制实现特征自动提取，结合LightGBM的高效分类，召回率达98.41%，F2-Score达98.23%，显著超越传统方法。采用GAN生成高质量流失样本，有效解决类别不平衡问题，引入SHAP值分析增强模型可解释性，构建“风险×价值”四象限客户分层体系。提出Doubly-Robust预算分配策略，融合ITE模型估计干预增量效应，实现ROI最大化（57%），净收益得到有效提升。开发增量学习机制，降低68%重训练成本。模拟实验显示可使客户流失率降低12%，预算利用率提升至95%。已设计B端决策支持平台原型，可快速部署至银行、零售、电商等领域， 具有广阔的商业化前景。',
          }
        ]

      },
      {
        alias: 'fourth',
        title: '最佳创意奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/2025/aiimage4.jpg'),
            title: '世佑 Sio 团队',
            product: '《EchoPolis —— 基于 AI 数字孪生的Z世代金融行为洞察引擎》',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '张鑫、邱新圣、李祈轩、廖梓熙',
            school: '南京大学',
            pro_intro: '我们想解决的核心痛点直击银行业面临的四大困境：获客、转化、竞争、风控。为了解决传统银行难以精准转化存量沉睡用户的行业困境，我们提出EchoPolis来了解用户行为、刻画用户画像。我们首创了“MES数字孪生模型”（Mirror分身、Echo回响、Sandbox沙盘），底层由DeepSeek大模型驱动。通过高沉浸感的“人生模拟”游戏交互，无感采集用户决策数据；结合NLP与行为经济学算法，将非结构化互动转化为精准的金融风险与偏好标签。我们期望系统双向赋能：对C端用户提供低门槛的金融认知互动；对B端银行实现从“精准获客”到“风险初筛”的一站式解决方案，并利用虚拟沙盘进行零成本的金融政策推演，深度挖掘长尾价值。',
          },
          {
            image: require('@/assets/transSave/resource/image/2025/saimage4.jpg'),
            title: 'Finfluence',
            product: '《社交影响力驱动微众银行产品生态的飞轮效应研究》',
            alias: 'statistics',
            type_title: '数据分析赛道',
            member: '蔡佳宜、肖思宇、马菁慧、李琛、黄文轩',
            school: '深圳大学',
            pro_intro: '本作品聚焦微众银行在微信生态中“借贷与理财业务割裂、用户价值挖掘不足、社交增长潜力未激活”的问题。创新点在于构建多维Finfluence评估体系，并设计“基石层-传播层-扩散层”三层社交网络，配合“借贷-理财”双向转化链条，结合网络拓扑分析、TemGNN动态风险预测及PyMC CLV模型，精准识别高价值用户并管控风险。方案在微信生态落地，通过AI Agent工作流实现用户价值智能挖掘，降低获客成本，提升用户生命周期价值和业务协同效率，为银行将社交关系转化为可持续商业增长提供数据驱动的可行路径。',
          }
        ]

      }
    ]
  },


  videos: {
    titleCh: '直播回顾',
    titleEn: '',
    list: [
      {
        imgUrl: 'https://static001.geekbang.org/business/wz/2025/img/video03.83e0ea7c.jpg',
        contentText: '2025 深圳国际金融科技大赛暨微众银行 2026 届校招宣讲会',
        video: 'https://www.infoq.cn/video/Lq9ymrII4Dqf7YNdOGwe'
      },
      {
        imgUrl: 'https://static001.geekbang.org/business/wz/2025/img/video01.ae563f58.jpg',
        contentText: '2025年深圳国际金融科技大赛 技术公开课',
        video: 'https://www.infoq.cn/video/rawPSuHo8lAayt81lHNi'
      }
    ],
    buttonText: '',
    buttonLink: ''
  }
}
